import 'bootstrap';
import React from 'react';
import Filters from '../Filters/section2';
import BarChart from '../Barchart/horizontal';
// import BarChartOthers from '../Barchart';
import getDoc from "../../qdoc";

export default class Section2 extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      yearMeasure: "num(Sum([Total Amount]),'$#,##0.00')",
    }

    this.changeYearMeasure = this.changeYearMeasure.bind(this);
  }

  changeYearMeasure(event) {
    this.setState({ yearMeasure: event.target.value });
  }

  clearSelections() {
    getDoc.then(doc => {
      doc.clearAll(false, 'State1');
    });
  }

  render() {
    return (
        <div className="container" id="S2">
        

        <section className="regional mb-5">
          <div className="apptitle mx-auto mb-3 mt-5">
              <h3>REGIONAL DONATIONS</h3>
              <div className="desc">
                <p>Many political donations are made on a national scale — in some cases by those banned from contributing in their own provinces (donation rules by region are listed <a href="https://shielded-basin-79840.herokuapp.com/political-donations/rules">here</a>).</p>
                <p>To see who is giving money beyond the riding where they live or have business headquarters, type a name into the search bar below. Names appear as they were submitted to elections agencies, so you may wish to search for multiple, related entries. For example, TD Bank has been registered as “TD Bank,” “Toronto Dominion Bank” and “TD Bank Financial Group.”</p>
                <p>Results may be viewed by amount or by how many contributions have been made.</p>

                {/* <p>Powerful corporations and unions, as well as many wealthy Canadians, make large donations outside the province where they live. Sometimes those donations have a significant impact on smaller jurisdictions. In the Yukon, for example, 34 per cent of all donations made since 2006 came from outside the territory — and some come from foreign interests seeking to influence Canadian politics.</p>
                <p>Names are recorded in the way they were submitted to the regional elections agency, so make sure you capture those variations if you’re looking for a complete picture. For example, TD Bank donated using over one hundred slight name variations including: “TD Bank”, “Toronto Dominion Bank” and “TD Bank Financial Group”.</p>
                <p>If you start typing in the donor name box it will generate results as you go. The type, region, political party and year boxes are drop down menus that you can also search in. On the top right corner you can select whether to display results by dollar amount or number of donations.</p> */}
              </div>
          </div>
            <div className="d-flex  align-items-end" style={{borderBottom:'2px solid #ECEEEF'}}>
              <div>
                Donations <span className="textgreen">by Region</span> 
              </div>
              <div className="ml-auto">
                <label className="custom-control custom-radio">
                  <input id="radio1" name="radio1" type="radio" className="custom-control-input" value="num(Sum([Total Amount]),'$#,##0.00')" checked={this.state.yearMeasure === "num(Sum([Total Amount]),'$#,##0.00')"} onChange={this.changeYearMeasure}/>                <span className="custom-control-indicator"></span>
                  <span className="custom-control-description">Amount</span>
                </label>
                <label className="custom-control custom-radio">
                <input id="radio2" name="radio1" type="radio" className="custom-control-input" value="num(Sum(DonationCount),'#,##0')" checked={this.state.yearMeasure === "num(Sum(DonationCount),'#,##0')"} onChange={this.changeYearMeasure}/>
                  <span className="custom-control-indicator"></span>
                  <span className="custom-control-description">Number of donatoins</span>
                </label>
              </div>
          </div>
          
          <div className="chartcontainer mt-2">
            
            <BarChart qStateName="State1" dimension="[Source]" measure={this.state.yearMeasure} sortorder={[1,0]} others="Other regions" leftMargin="120" rightMargin="120"/>
          </div>

        <Filters/>
          
        </section>

        </div>
    );
  }
}



        


// WEBPACK FOOTER //
// ./components/Sections/section2.js